import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NarrativePage from './NarrativePage';
import CommercialPage from './CommercialPage';
import './HomePage.css';

function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return undefined;

    const frame = window.requestAnimationFrame(() => {
      document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [location.hash]);

  return (
    <main className="home-page">
      <section className="home-section" id="films">
        <NarrativePage />
      </section>
      <section className="home-section" id="commercial">
        <CommercialPage />
      </section>
    </main>
  );
}

export default HomePage;
